import { PaperBagsWithHandlesFields } from "./types";

export const dimensionsInput: Array<
  | PaperBagsWithHandlesFields.length
  | PaperBagsWithHandlesFields.width
  | PaperBagsWithHandlesFields.folding
> = [
  PaperBagsWithHandlesFields.length,
  PaperBagsWithHandlesFields.width,
  PaperBagsWithHandlesFields.folding,
];
